<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="APPID">
              <a-input placeholder="请输入APPID" v-model="queryParam.appId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="5" :md="6" :sm="24" :xl="4">
            <a-form-item label="客户端">
              <j-multi-select-tag
                dictCode="app_client"
                placeholder="请选择客户端"
                type="checkbox"
                v-model="queryParam.appClient"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="7" :sm="24" :xl="5">
            <a-form-item label="外部版本号">
              <a-input placeholder="请输入外部版本号" v-model="queryParam.versionCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="6" :md="7" :sm="24" :xl="5">
            <a-form-item label="更新方式">
              <j-multi-select-tag
                dictCode="app_upgrade_type"
                placeholder="请选择更新方式"
                type="checkbox"
                v-model="queryParam.upgradeType"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="5" :md="6" :sm="24" :xl="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('APP版本升级记录')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <app-version-upgrade-log-modal @ok="modalFormOk" ref="modalForm"></app-version-upgrade-log-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import AppVersionUpgradeLogModal from './modules/AppVersionUpgradeLogModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'AppVersionUpgradeLogList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      AppVersionUpgradeLogModal
    },
    data () {
      return {
        description: 'APP版本升级记录管理页面',
        isorter: {
          column: 'versionCode',
          order: 'desc',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: 'APPID',
            align: "center",
            dataIndex: 'appId',
            sorter: true,
          },
          {
            title: '客户端',
            align: "center",
            dataIndex: 'appClient_dictText',
            sorter: true,
          },
          {
            title: '内部版本号',
            align: "center",
            dataIndex: 'version',
            sorter: true,
          },
          {
            title: '外部版本号',
            align: "center",
            dataIndex: 'versionCode',
            sorter: true,
          },
          {
            title: '强制更新',
            align: "center",
            dataIndex: 'isForce_dictText',
            sorter: true,
          },
            {
            title: '发布模式',
            align: "center",
            dataIndex: 'releaseMode_dictText',
            sorter: true,
          },
          {
            title: '安装包',
            align: "center",
            dataIndex: 'upgradeUrl',
            scopedSlots: { customRender: 'fileSlot' }
          },
          {
            title: '更新方式',
            align: "center",
            dataIndex: 'upgradeType_dictText',
            sorter: true,
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/custom/appVersion/list",
          delete: "/custom/appVersion/delete",
          deleteBatch: "/custom/appVersion/deleteBatch",
          exportXlsUrl: "/custom/appVersion/exportXls",
          importExcelUrl: "custom/appVersion/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'appId', text: 'APPID', dictCode: '' })
        fieldList.push({ type: 'string', value: 'appClient', text: '客户端', dictCode: 'app_client' })
        fieldList.push({ type: 'int', value: 'version', text: '内部版本号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'versionCode', text: '外部版本号', dictCode: '' })
        fieldList.push({ type: 'int', value: 'isForce', text: '强制更新', dictCode: 'yn' })
        fieldList.push({ type: 'string', value: 'upgradeType', text: '更新方式', dictCode: 'app_upgrade_type' })
        fieldList.push({ type: 'string', value: 'upgradeUrl', text: '安装包', dictCode: '' })
        fieldList.push({ type: 'string', value: 'upgradePoint', text: '升级提示', dictCode: '' })
        fieldList.push({ type: 'int', value: 'status', text: '状态(0禁用 1启用)', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>